export default "__VITE_PUBLIC_ASSET__2962372a__"